export default __webpack_public_path__ + "5c4a36bec907162a9353d0eb6d818ff3.png";